document.addEventListener('DOMContentLoaded', () => {
    const bars = document.querySelectorAll('.announcement-bar');

    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const bar = entry.target;
                if (entry.isIntersecting) {
                    startAnimation(bar);
                } else {
                    stopAnimation(bar);
                }
            });
        }, { threshold: 0 });

        bars.forEach(bar => observer.observe(bar));
    } else {
        bars.forEach(bar => startAnimation(bar));
    }

    function startAnimation(bar) {
        if (bar.dataset.intervalId) return; // Already running

        const animationType = bar.dataset.animationType;
        if (animationType === 'marquee') return; // Marquee is CSS-only

        const track = bar.querySelector('.announcement-track');
        if (!track) return;

        // Ensure we find items. For slide, they are direct children.
        const items = track.querySelectorAll('.announcement-item');
        if (items.length <= 1) return;

        const direction = bar.dataset.direction;
        const intervalTime = parseInt(bar.dataset.interval) || 4000;

        let index = 0;
        const itemCount = items.length;

        const intervalId = setInterval(() => {
            index = (index + 1) % itemCount;

            if (direction === 'vertical') {
                track.style.transform = `translateY(-${index * 100}%)`;
            } else {
                track.style.transform = `translateX(-${index * 100}%)`;
            }
        }, intervalTime);

        bar.dataset.intervalId = intervalId;
    }

    function stopAnimation(bar) {
        if (bar.dataset.intervalId) {
            clearInterval(parseInt(bar.dataset.intervalId));
            delete bar.dataset.intervalId;
        }
    }
});
